import { render, staticRenderFns } from "./CoinIcon.vue?vue&type=template&id=4024069e&scoped=true"
import script from "./CoinIcon.vue?vue&type=script&lang=js"
export * from "./CoinIcon.vue?vue&type=script&lang=js"
import style0 from "./CoinIcon.vue?vue&type=style&index=0&id=4024069e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024069e",
  null
  
)

export default component.exports